<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on, attrs }" v-if="id==null">
        <v-btn color="primary" dark v-bind="attrs" v-on="on" @click="$refs.form.reset()">
          {{ $t("btn.UploadSlide") }}
        </v-btn>
      </template>
      <template v-slot:activator="{ on, attrs }" v-else-if="id!=null">
        <v-btn icon color="orange" v-bind="attrs" v-on="on" class="btn-card">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ $t("btn.UploadSlide") }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12">
                  <v-img  :src="SRC" class="grey lighten-2"></v-img>
                </v-col>
                <v-col cols="12">
                  <v-file-input show-size counter label="ภาพ Slide (1,500px * 470px)" required :rules="(id==null ? FileRules:[])" accept="image/png, image/jpeg, image/bmp" prepend-icon="mdi-camera" v-model="FileSlide"></v-file-input>
                </v-col>
                <v-col cols="6">
                  <v-menu v-model="menuStartDate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="StartDate" label="เริ่มแสดงวันที่" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="StartDate" @input="menuStartDate = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6">
                   <v-menu v-model="menuEndDate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="EndDate" label="ถึงวันที่" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="EndDate" @input="menuEndDate = false" :min="StartDate"></v-date-picker>
                   </v-menu>
                </v-col>
                <v-col cols="12">
                   <v-text-field prepend-icon="mdi-link-variant" label="URL" v-model="URL" dense></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false" :loading="$store.getters.overlay">
            Close
          </v-btn>
          <v-btn color="blue darken-1" text @click="SaveClick" :loading="$store.getters.overlay">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
      
    </v-dialog>


    <v-dialog v-model="dialogComplete" persistent max-width="400">
      <v-card>
        <v-card-title class="text-h5">
          บันทึกข้อมูลเรียบร้อย
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="ClickComplete">
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>
  export default {
      props: {
      StartDate: String,
      EndDate: String,
      URL: String,
      SRC: String,
      id: Number
    },
    data: () => ({
      dialog: false,
      FileSlide:null,
      valid:false,
      dialogComplete:false,
      menuStartDate:false,
      menuEndDate:false,
      FileRules: [
        v => !!v || 'File is required'
      ],
      req:{},
    }),
    methods: {
      
      SaveClick() {
        if(this.$refs.form.validate()){
          this.$store.commit('set_overlay',true);
          let formData = new FormData();

          if(typeof this.id !== 'undefined'){
            formData.append('id'      ,this.id);
          }
          formData.append('StartDate',this.StartDate);
          formData.append('EndDate'  ,this.EndDate);
          formData.append('URL'    ,(typeof this.URL === 'undefined' || this.URL=='null' || this.URL==null? '' : this.URL));
          if(this.FileSlide !== null){
            formData.append('FileSlide',this.FileSlide,this.FileSlide.name);
          }
          this.req.post(this.$store.getters.base_api + 'post-upload-landing-slide',formData,{ headers: {'Content-Type': 'multipart/form-data'},})
                .then(response=>{
                  this.dialog = false;
                  this.dialogComplete = true;
                  this.$store.commit('set_overlay',false);
               }).catch(error => {
                  this.$store.commit('set_overlay',true);
              });
        }
      },
      ClickComplete(){
        this.dialogComplete = false;
        this.$emit('complete');
      },
    },
    mounted() {
      this.req = this.$store.getters.req;
    },
  }
</script>